import { Chip, Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  chipFiltro: {
    '& .MuiChip-deleteIcon': {
      color: 'rgb(from currentColor r g b / 0.26)',
    },
    '& .MuiChip-deleteIcon:hover': {
      color: theme.palette.text.disabled,
    },
  },
}))

const defaultGetLabel = (option) => {
  if (option == null) return ''
  if (typeof option === 'string' || typeof option === 'number') return String(option)
  return option.nome || ''
}

export const AutocompleteTags = ({ tagValue, getTagProps, getLabel = defaultGetLabel, getTooltip }) => {
  const classes = useStyles()
  return (
    <>
      {tagValue.map((option, index) => (
        <Tooltip title={getTooltip ? getTooltip(option) : ''} arrow placement="top-start" style={{ marginInline: '2px' }} key={option?.id || option || index}>
          <Chip label={getLabel(option)} {...getTagProps({ index })} className={classes.chipFiltro} />
        </Tooltip>
      ))}
    </>
  )
}
